/* @ngInject */
class Employees {
	constructor($http) {
		this.$http = $http;
	}

	get(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesNowHeadcount() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/summaries/now/headcount`,
		);
	}

	getSummariesNowRegions() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/summaries/now/regions`,
		);
	}

	getSummariesNowExceptionsVisits() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/summaries/now/exceptions-visits`,
		);
	}

	getSummariesHistoricalHeadcount(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/summaries/historical/headcount`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesHistoricalRegions(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/summaries/historical/regions`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesExceptionsVisits(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/summaries/exceptions-visits`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesExclusions(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/summaries/exclusions`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesExited(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/summaries/exited`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesSupervisoryMeetings(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/summaries/supervisory-meetings`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesTurnover(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/summaries/turnover`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesUnableToCover(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/summaries/unable-to-cover`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getOthersHighestId() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/others/highest-id`,
		);
	}

	getIndividualsActive() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/individuals/active`,
		);
	}

	getIndividualsInactive() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/individuals/inactive`,
		);
	}

	getIndividualsFinished() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/individuals/finished`,
		);
	}

	getIndividualsOfficeStaff() {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/employees/individuals/office-staff`,
		);
	}

	updateOneSupportWorker(supportWorkerId, data) {
		return this.$http.post(
			`${process.env.API_ENDPOINT}support-workers/${supportWorkerId}`, data,
		);
	}

	markOneVisitAsProcessed(visitId) {
		return this.$http.post(`${process.env.API_ENDPOINT}roster/${visitId}/process`);
	}
}

export default Employees;


// WEBPACK FOOTER //
// ./src/js/services/staff/reports/employees/index.js